export default __webpack_public_path__ + "static/media/Workspace Logo Basic Template.9cb7665b.pdf";